<template>
  <div>
    <div class="grid-item grid-item-header cart-item">
      <div class="articul">
        <span>{{ $t('product_code') }}</span>
      </div>
      <div class="brand">
        <span>{{ $t('brand') }}</span>
      </div>
      <div class="name">
        <span>{{ $t('product_name') }}</span>
      </div>
      <div class="store store_name">
        <span>{{ $t('availability') }}</span>
      </div>
      <div class="store store_qnt">
        <span>{{ $t('store_pcs') }}</span>
      </div>
      <div class="price">
        <span>{{ $t('price_rub') }}</span>
        <span class="upper">{{ $t('no_vat') }}</span>
      </div>
      <div class="order">
        <span>{{ $t('quantity') }}</span>
      </div>
      <div class="total">
        <span>{{ $t('sum_rub') }}</span>
        <span class="upper">{{ $t('no_vat') }}</span>
      </div>
    </div>

    <template v-for="product in products">
      <cart-list-item
        class="container"
        :key="product.id"
        :product="product"
        :stocks="stocks"
        @fetch-cart="$emit('fetch-cart')"
      />
      <cart-list-item-supplier 
        class="container"
        v-for="supplier in product.suppliers"
        :key="`suppl-${supplier.stock.id}-${product.id}`"
        :product="product"
        :stocks="stocks"
        :supplier="supplier"
        @fetch-cart="$emit('fetch-cart')"
      />
    </template>
  </div>
</template>

<script>
import CartListItem from '@/components/cart/cart-list-item';
import CartListItemSupplier from '@/components/cart/cart-list-item-supplier';

export default {
  components: {
    CartListItem,
    CartListItemSupplier,
  },
  props: [
    'products',
    'stocks',
    'cart'
  ],
}
</script>
